import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import ContactForm from '../components/ContactForm';
import Icon from '@mdi/react'
import { mdiEmailOutline, mdiFacebook, mdiInstagram, mdiTwitter, mdiLinkedin, mdiXing, mdiYoutube } from '@mdi/js'
import PropTypes from 'prop-types';
import ReactMarkdown from "react-markdown";
import Helmet from 'react-helmet';

const ContactPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.ContactPageData.edges[0]
  return (
      <Layout>
         <Helmet>
          <html lang={locale === 'en' ? 'en' : 'de'} />
            <title>
              {
                locale === 'en' ?
                  'Contact - presono' :
                  'Kontakt - presono'
              }
            </title>
            <meta
              name="description"
              content={
                locale === 'en' ?
                  'Contact presono via the content form, via email or call us.' :
                  'Kontaktieren Sie presono über das Kontaktformular, per Email oder rufen Sie uns an.'
              }
            />
        </Helmet>
        <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
        <section className="support">
          <section className="headliner starfield t1 b2 pusher">
            <div className="container">
              <div className="column">
                <ReactMarkdown source={data.frontmatter.contactHeadline} />
                <p>
                  {data.frontmatter.contactHeadlineSubtext}
                </p>
              </div>
            </div>
          </section>
          <section className="contact">
            <div className="container">
              <div className="columns">
                <div className="column is-6">
                  <ContactForm locale={locale} />
                </div>
                <div className="column is-6">
                  <div className="support-container special-bg">
                  <div className="columns">
                    <div className="column is-full logos spacer">
                      <div className="columns">
                        <div className="column is-12 card">
                          <div className="media-content" itemScope itemType="http://schema.org/Organization">
                            <h3>{ locale === "en" ? "Contact" : "Kontakt" }  </h3>
                            <ul itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                              <li itemProp="email">info@presono.com</li>
                              <li itemProp="telephone" >+43 650/9808035</li>
                              <br/>
                              <li itemProp="name"> presono GmbH </li>
                              <li itemProp="streetAddress">Landstrasse 15</li>
                              <li itemProp="postalCode">A-4020 Linz</li>
                            </ul>
                            <a rel="noopener noreferrer" href="mailto:info@presono.com">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon
                                    path={mdiEmailOutline}
                                    size={0.8}
                                    color="#fff"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="columns is-hidden-mobile">
                      <div className="column is-full logos">
                        <div className="columns lower socialbox card">
                          <div className="column is-4">
                            <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/presono">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiFacebook}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                            <a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/company/presono/">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiLinkedin}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="column is-4">
                            <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/_presono">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiInstagram}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                            <a rel="noopener noreferrer" target="_blank" href="https://www.xing.com/companies/presonosmartinformationgmbh">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiXing}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="column is-4">
                            <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/presono_startup">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiTwitter}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                            <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/channel/UCjJoIsOqQIfN-GMhG-YUbVQ">
                              <div className="circle-ar">
                                <div className="icon-ar">
                                  <Icon path={mdiYoutube}
                                    size={0.8}
                                    color="#fff"
                                    />
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <Newsletter newsletter={data.frontmatter} locale={locale} />
        <Footer locale={locale} />
      </Layout>
  )
}

export default ContactPage;

ContactPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query ContactContent($locale: String) {
  ContactPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_contact"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          contactHeadline
          contactHeadlineSubtext
          langSwitch
        }
      }
    }
  }
}
`
